import { scrubRynReplayConsoleArg } from '@ups/xplat/base/ryn-replay';

export const RYN_REPLAY_CONSOLE_ARG_MAX_CHARS = 2_000;
export const RYN_REPLAY_NETWORK_BODY_MAX_CHARS = 32_000; // > 4,000 stored cap: ingest redacts, then truncates (WI 34576)
export { RYN_REPLAY_CONSOLE_SCRUB_MAX_DEPTH } from '@ups/xplat/base/ryn-replay';

export const scrubConsoleArg = scrubRynReplayConsoleArg;

export const safeSerialize = (value: unknown, maxChars: number): unknown => {
  try {
    if (typeof value === 'string') {
      return value.length > maxChars ? `${value.slice(0, maxChars)}…` : value;
    }
    if (
      typeof value === 'number' ||
      typeof value === 'boolean' ||
      value === null
    ) {
      return value;
    }
    if (value instanceof Error) {
      return {
        name: value.name,
        message: value.message.slice(0, maxChars),
      };
    }
    const json = JSON.stringify(value);
    if (json === undefined) {
      return String(value).slice(0, maxChars);
    }
    return json.length > maxChars
      ? `${json.slice(0, maxChars)}…`
      : JSON.parse(json);
  } catch {
    try {
      return String(value).slice(0, maxChars);
    } catch {
      return '[unserializable]';
    }
  }
};
